/* eslint-disable camelcase */
/** @return {import("child_process")} */
const child_process = () => window.nodeModules?.child_process;

export default child_process;
